import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MaterialModule } from "../../material/material.module";
import { OnboardingComponent } from "../../ui-components/onboarding/onboarding.component";

@Component({
    selector: 'introduction-dialog',
    templateUrl: 'introduction-dialog.html',
    imports: [MaterialModule, OnboardingComponent],
    standalone: true,
    styleUrls: ['introduction-dialog.css']
})
export class IntroductionDialogComponent {
   
    constructor(public dialogRef: MatDialogRef<IntroductionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data:any) {
        
    }

    closeDialog(action:string) {
        this.dialogRef.close(action);
    }
}
